"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftNavigation = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var Types = require("types");
var AclUtils = require("utils/acl");
var LoginActions = require("@caddigital/sok-reducers/lib/actions/auth/login");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var NavigationActions = require("actions/navigation");
var avatars_1 = require("components/Avatar/avatars");
var viewport_1 = require("reducers/viewport");
var translate_1 = require("utils/translate");
var types_1 = require("./types");
var utils_1 = require("./utils");
var buildInfo_1 = require("../../buildInfo");
require("./index.scss");
var defaultImage = (0, avatars_1.getAvatar)(0);
var mapStateToProps = function (state) {
    var _a, _b;
    var perm = 0x00;
    var projectId;
    if (state.project.currentProject.status === 'FETCHED' &&
        state.project.currentProject.project.perm) {
        perm = state.project.currentProject.project.perm;
        projectId = state.project.currentProject.project.id;
    }
    return {
        pathname: state.router.location.pathname,
        selectedLanguage: (0, translate_1.getLanguage)() || '',
        isOpen: state.navigation.isOpen,
        isShrunk: state.navigation.isShrunk,
        isMobile: (0, viewport_1.isMobile)(state.viewport),
        location: state.router.location.key,
        user: state.auth.current.user,
        features: state.auth.current.features,
        currentProject: state.project.currentProject,
        perm: perm,
        bid: state.bid.current.bid,
        search: state.router.location.search,
        projectId: projectId,
        buildInfo: (_b = (_a = state.info) === null || _a === void 0 ? void 0 : _a.buildInfo) !== null && _b !== void 0 ? _b : null
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    onClose: function () { return dispatch(NavigationActions.closeNavigationMenu()); },
    onOpen: function () { return dispatch(NavigationActions.openNavigationMenu()); },
    logout: function () { return dispatch(LoginActions.logout()); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('currentMenu', 'setCurrentMenu', types_1.NavigationTypes.MAIN), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        var navigationType = (0, utils_1.identifyNavigationType)(this.props.pathname);
        this.props.setCurrentMenu(navigationType);
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.pathname === prevProps.pathname) {
            return;
        }
        var navigationType = (0, utils_1.identifyNavigationType)(this.props.pathname);
        this.props.setCurrentMenu(navigationType);
    }
}), recompose_1.pure);
var cleanBuildVersion = function (version) {
    return version.replace('dev-', '').substring(0, 16);
};
var component = function (props) {
    var _a;
    var menu = (0, utils_1.createMenu)(props);
    var isBuildInfoVisible = (props.isMobile && props.isOpen) || (!props.isMobile && !props.isShrunk);
    return (React.createElement(sok_ui_1.NavigationMenu, { isOpen: props.isOpen, isShrunk: props.isShrunk, onClose: props.onClose },
        menu.back,
        React.createElement(sok_ui_1.NavigationMenuHeader, { image: props.user
                .map(function (info) { return (0, avatars_1.getAvatarUrl)(info.avatar); })
                .getOrElse(defaultImage), backgroundImage: '/assets/backgrounds/everest.jpg', name: props.user
                .map(function (info) { return "".concat(info.firstName, " ").concat(info.lastName); })
                .getOrElse(''), email: props.user.map(function (info) { return info.email; }).getOrElse('') }),
        menu.items,
        React.createElement(sok_ui_1.NavigationMenuSpacer, null),
        React.createElement(sok_ui_1.NavigationMenuItem, { icon: React.createElement(sok_ui_1.Icon, { className: 'fa-stars' }), text: (0, translation_1.getLocalization)('leftnavigation/sokoProProducts'), onClick: function () {
                return window.open((0, utils_1.getSokoProProductsUrl)(props.selectedLanguage), '_blank', 'noreferrer');
            } }),
        React.createElement(sok_ui_1.NavigationMenuSpacer, null),
        React.createElement(sok_ui_1.NavigationMenuItem, { onClick: function () {
                props.logout();
                props.onClose();
            }, icon: React.createElement(sok_ui_1.Icon, { className: 'fa-sign-out' }), text: (0, translation_1.getLocalization)('leftnavigation/logout') }),
        AclUtils.isSuperAdmin(props.user) && isBuildInfoVisible && (React.createElement(React.Fragment, null,
            React.createElement(sok_ui_1.NavigationMenuSpacer, null),
            React.createElement(sok_ui_1.BuildInfo, { clientLabel: "Client", clientVersion: cleanBuildVersion(buildInfo_1.BUILD_VERSION || '—'), serverLabel: "Server", serverVersion: cleanBuildVersion(((_a = props.buildInfo) === null || _a === void 0 ? void 0 : _a.version) || '—') })))));
};
exports.LeftNavigation = enhance(component);
